import Inter_Light_woff2_namespaceObject from "../../static/font/Inter-Light.woff2";
export default Inter_Light_woff2_namespaceObject;
